import React, { Component } from 'react'
import { NavLink, withRouter } from 'react-router-dom'

export default class Sidebar extends Component {
	render() {
		return (
			<div className="services-sidebar">
				<h3><img src={require('./moshi-small.png')} alt="Small" style={{marginBottom:-2, marginTop: -2}} /> Marketing</h3>
				<ul>
					<li>
						<NavLink to="/whatwedo/google-ads">Google Adwords & SEO</NavLink>
					</li>
					<li>
						<NavLink to="/whatwedo/social-media-marketing">Social Media Marketing</NavLink>
					</li>
				</ul>
				<h3><img src={require('./moshi-small.png')} alt="Small" style={{marginBottom:-2, marginTop: -2}} /> Graphics Design</h3>
				<ul>
					<li>
						<NavLink to="/whatwedo/graphic-design">Graphic Design</NavLink>
					</li>
					<li>
						<NavLink to="/whatwedo/brand-and-logo-design">Brand and Logo design</NavLink>
					</li>
				</ul>
				<h3><img src={require('./moshi-small.png')} alt="Small" style={{marginBottom:-2, marginTop: -2}} /> Web / App Development</h3>
				<ul>
					<li>
						<NavLink to="/whatwedo/website-development">Website Development</NavLink>
					</li>
					<li>
						<NavLink to="/whatwedo/app-development">App Development</NavLink>
					</li>
				</ul>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/Pages/WhatWeDo/Sidebar.js